import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { fetchBranding } from "@/lib/company";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Load the tenant timezone/locale before first paint (capped at 3s so a
// slow or offline network never blocks the app; last-known tz is cached).
const brandingReady = Promise.race([
  fetchBranding(),
  new Promise((r) => setTimeout(r, 3000)),
]);

// Service worker for every visitor (not just push-enabled drivers): offline
// app shell, offline read cache and background photo sync. Persistent
// storage stops Chrome clearing queued photos when the phone is low on space.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
navigator.storage?.persist?.().catch(() => {});

const root = ReactDOM.createRoot(document.getElementById("root"));
brandingReady.then(() => root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
));
